export const createGameAnalyticsSlice = (props)=>()=>({
            gameAnalytics: {
                sendSettingsOpenedAnalytics: props.sendSettingsOpenedAnalytics,
                sendSettingsClosedAnalytics: props.sendSettingsClosedAnalytics,
                sendSettingsTabClickedAnalytics: props.sendSettingsTabClickedAnalytics,
                sendSettingsValueChangedAnalytics: props.sendSettingsValueChangedAnalytics,
                sendRushGameEndTurnAnalytics: props.sendRushGameEndTurnAnalytics,
                sendGiftMembershipClickAnalytics: props.sendGiftMembershipClickAnalytics,
                sendEndgameAdBoxClickAnalytics: props.sendEndgameAdBoxClickAnalytics,
                sendRushAdImpressionAnalytics: props.sendRushAdImpressionAnalytics,
                sendRushAdClickAnalytics: props.sendRushAdClickAnalytics,
                sendWasDiceUnfairAnalytics: props.sendWasDiceUnfairAnalytics,
                sendMobilePausedGameAnalytics: props.sendMobilePausedGameAnalytics,
                sendUserAccessedChatAnalytics: props.sendUserAccessedChatAnalytics,
                sendUserAccessedLogAnalytics: props.sendUserAccessedLogAnalytics,
                sendFullScreenMembershipAnalytics: props.sendFullScreenMembershipAnalytics,
                sendMobileResumedGameAnalytics: props.sendMobileResumedGameAnalytics,
                sendInGameInfoWindowViewedAnalytics: props.sendInGameInfoWindowViewedAnalytics,
                sendInGameInfoWindowClosedAnalytics: props.sendInGameInfoWindowClosedAnalytics,
                sendInGameInfoWindowTabChangedAnalytics: props.sendInGameInfoWindowTabChangedAnalytics
            }
        });
